<template>
  <div class="menuList">
    <div
      class="menuItem"
      v-for="(item, index) in menuList"
      :key="index"
      @click="changeStatus(item)"
    >
      {{ item.value ? item.CloseName : item.OpenName }}
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  switchOutside, //开关厂棚外侧
  switchLight, // 开关光照
  switchTarget, // 显隐光标
  switchPillar, // 显隐藏中立柱
  switchAllEqmHL, //开关设备高亮
  switchPartEqmHL, //开关部分设备高亮
  switchSingleHL, // 单个设备高亮
  ChangePileSizeFunc, //改变料堆大小
  switchAreaWarn, //开关告警区域
  switchAreaWarnClean, //开关已治理告警区域
  switchVDM3500, //开关vdm3500
  switchVDM150, //开关vdm150
  switchFogGun, // 开关雾炮
  switchMediaArea, //切换视频区域
  ChangeBarrelSizeFunc, //改变堆料大小
  switchBarrel, //开关料堆
  switchEqmWarn, //开关设备报警
  SelectEquipmentFunc, //选择设备
  switchMaterialCarSim, //开关布料小车仿真
  ContinueMaterialCarSimFunc, //继续仿真
  MaterialCarTurnToPileFunc, //小车皮带转向料堆
  MaterialCarTurnToBarrleFunc, //小车皮带转向料桶
  MaterialCarInitCameraPosFunc, //飞跃相机
  switchCarCamera, //启停相机动画
  switchSpray, //开启喷淋和落料动画
  switchCarBelt, // 开关小车皮带
  MaterialCarMoveFunc, // 小车移动
  backToLocationFun, // 镜头移动
  ChangeDropPileFunc,
} from "@/assets/js/unity3D/shed.js";

export default {
  data() {
    //这里存放数据
    return {
      menuList: [
        {
          OpenName: "显示厂棚外侧",
          CloseName: "隐藏厂棚外侧",
          func: switchOutside,
          value: false,
        },
        {
          OpenName: "回到默认位置",
          CloseName: "回到默认位置",
          func: this.backPosOne,
          noChange: false,
        },
        {
          OpenName: "开启灯光",
          CloseName: "关闭灯光",
          func: switchLight,
          value: true,
        },
        // {
        //   OpenName: "显示光标",
        //   CloseName: "隐藏光标",
        //   func: switchTarget,
        //   value: false,
        // },
        // {
        //   OpenName: "隐藏料桶",
        //   CloseName: "显示料桶",
        //   func: this.showShedBox,
        //   value: true,
        // },
      ],
      shedBoxList: ["0,1", "0,2", "0,3", "0,4", "0,5", "0,6", "0,7", "0,8"],
      areaList: ["0,1", "0,2", "0,3", "0,4", "1,1", "1,2", "1,3", "1,4"],
    };
  },
  inject: ["switchMaterialShedInfo", "backPos"],
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      switchTarget(false);
      this.menuList.forEach((i) => {
        if (i.OpenName === "显示厂棚外侧") {
          this.changeStatus(i);
        }
      });
      // this.areaList.forEach((i) => {
      //   ChangeDropPileFunc(i + ",0,10");
      // });
    }, 500);
  },
  beforeUnmount() {},
  //方法集合
  methods: {
    changeStatus(item) {
      // if(item.noChange) {
      //   item.backToLocationFun("0,0,0")
      // }
      item.value = !item.value;
      item.func(item.value);
      if (item.OpenName === "显示厂棚外侧") {
        if (item.value) {
          backToLocationFun("0,0,1");
          this.switchMaterialShedInfo(true);
        } else {
          backToLocationFun("0,0,0");
          this.switchMaterialShedInfo(false);
        }
      }
    },
    backPosOne() {
      backToLocationFun("0,0,0");
    },
    showShedBox(value) {
      // console.log(value);
      switchPillar(value);
      this.shedBoxList.forEach((i) => {
        switchBarrel(i, !value);
      });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.menuList {
  position: absolute;
  left: 0px;
  bottom: 10px;
  right: 0px;
  margin: auto;
  display: flex;
  width: 600px;
  height: 200px;
  justify-content: space-between;
  .menuItem {
    cursor: pointer;
    letter-spacing: 1px;
    font-size: 24px;
    width: 164px;
    height: 84px;
    line-height: 84px;
    text-align: center;
    background: url("./img/road_bg.png") no-repeat 100%;
  }
}
</style>